import { BaseFilter, FiltersDeclaration } from '../types/Filters';
import { getDynamicFilterList } from './getDynamicFilterList';

/**
 * Метод получения списка всех фильтров из декларации
 * @param filtersDeclaration декларация фильтров
 * @typeParam Filter тип фильтра
 * @returns список всех фильтров декларации
 * @kind helper
 */
export function getFilterList<Filter extends BaseFilter>(filtersDeclaration: FiltersDeclaration<Filter>): Filter[] {
    // Тут в будущем добавятся quickFilters и customFilters
    return getDynamicFilterList(filtersDeclaration.dynamicFilters);
}
